var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medical",
    transform: "translate(-511 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 52,
    height: 52,
    rx: 12,
    transform: "translate(511 169)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "medical-2",
    "data-name": "medical",
    transform: "translate(172 -113)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 36,
    height: 36,
    transform: "translate(347 290)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16036",
    "data-name": "Group 16036",
    transform: "translate(-0.169 -0.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16035",
    "data-name": "Group 16035",
    transform: "translate(-14.244 -0.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_23_-_Outline",
    "data-name": "Subtraction 23 - Outline",
    d: "M15.325,4.727V1.657a.415.415,0,0,0-.414-.415H1.657a.415.415,0,0,0-.414.415v3.07H15.325m1.243.243H0V1.657A1.659,1.659,0,0,1,1.657,0H14.911a1.659,1.659,0,0,1,1.657,1.657Z",
    transform: "translate(371.04 297)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16034",
    "data-name": "Group 16034",
    transform: "translate(364.413 301.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27752",
    "data-name": "Path 27752",
    d: "M2.13,1.243a.925.925,0,0,0-.888.956V16.855a.925.925,0,0,0,.888.956H27.692a.925.925,0,0,0,.888-.956V2.2a.925.925,0,0,0-.888-.956H2.13M2.13,0H27.692a2.165,2.165,0,0,1,2.13,2.2V16.855a2.165,2.165,0,0,1-2.13,2.2H2.13A2.165,2.165,0,0,1,0,16.855V2.2A2.165,2.165,0,0,1,2.13,0Z",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16033",
    "data-name": "Group 16033",
    transform: "translate(8.698 3.313)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_883",
    "data-name": "Ellipse 883",
    cx: 6.213,
    cy: 6.213,
    r: 6.213,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_883_-_Outline",
    "data-name": "Ellipse 883 - Outline",
    d: "M6.213,1.243a4.97,4.97,0,1,0,4.97,4.97,4.976,4.976,0,0,0-4.97-4.97M6.213,0A6.213,6.213,0,1,1,0,6.213,6.213,6.213,0,0,1,6.213,0Z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16010",
    "data-name": "Group 16010",
    transform: "translate(3.697 3.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_742",
    "data-name": "Line 742",
    d: "M.76,5.032H-.75V0H.76Z",
    transform: "translate(2.46 0)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_743",
    "data-name": "Line 743",
    d: "M1.51,5.032H0V0H1.51Z",
    transform: "translate(5.032 1.624) rotate(90)",
    fill: "#19bc9c"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.0552df43f94015802e8b2ed8de71252c.svg";
export { ForwardRef as ReactComponent };